import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';

const Toast = ({
  type = 'success',
  message,
  onClose = () => {},
}: {
  type?: 'success' | 'error' | 'warning' | 'info';
  message: string;
  onClose: () => void;
}) => {
  const configs = {
    success: {
      icon: CheckCircle,
      iconColor: 'text-emerald-500',
      bg: 'bg-gradient-to-br from-emerald-100 to-emerald-200',
    },
    error: {
      icon: AlertCircle,
      iconColor: 'text-secondary-500',
      bg: 'bg-gradient-to-br from-secondary-100 to-secondary-200',
    },
    warning: {
      icon: AlertTriangle,
      iconColor: 'text-primary-500',
      bg: 'bg-gradient-to-br from-primary-100 to-primary-200',
    },
    info: {
      icon: Info,
      iconColor: 'text-blue-500',
      bg: 'bg-gradient-to-br from-blue-100 to-blue-200',
    },
  };

  const config = configs[type];
  const Icon = config.icon;

  return (
    <div
      className={`flex items-center gap-3.5 p-4 px-6 ${config.bg} animate-bounceIn max-w-[480px] min-w-[340px] rounded-3xl shadow-lg`}
    >
      <div className="flex-shrink-0 rounded-full bg-white p-2 shadow-md">
        <Icon size={20} className={config.iconColor} strokeWidth={2.5} />
      </div>

      <span className="flex-1 text-[15px] leading-relaxed font-semibold text-gray-800">
        {message}
      </span>

      <button
        onClick={onClose}
        className="rounded-full bg-white/60 p-2 transition-all duration-200 hover:scale-110 hover:bg-white/90"
      >
        <X size={16} className="text-gray-500" />
      </button>
    </div>
  );
};

export default Toast;
